import { StyleSheet } from 'aphrodite';
import { midGrey, titles } from '../../../styles/colors';
import { SPACE } from '../../../components-v2/Theme/theme';
import { baseStyleSheet } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	bold: {
		...baseStyleSheet.fontBold,
	},
	cancelOnReplyCheckbox: {
		marginTop: 14,
	},
	cancelOnReplyCheckboxText: {
		width: 500,
	},
	checkboxText: {
		color: '#4a4a4a',
		fontSize: 14,
		marginBottom: 2,
		marginLeft: 16,
		width: 300,
	},
	daysBetweenInput: {
		textAlign: 'center',
		width: 30,
	},
	daysBetweenTextInput: {
		margin: '0 5px',
	},
	eventRegistrationTriggerDisclaimer: {
		marginTop: 20,
	},
	eventAutomationCoverageWarning: {
		marginTop: SPACE[16],
	},
	searchBox: {
		backgroundColor: '#f9f9f9',
		color: '#4a4a4a',
		display: 'inline-block',
		fontSize: 14,
		height: 40,
		outline: 'none',
		verticalAlign: 'middle',
		width: 458,
	},
	textingTriggerCheckboxText: {
		width: 458,
	},
	triggerSelect: {
		marginTop: 14,
		maxWidth: '100%',
		width: '100%',
	},
	triggerSettingsCheckbox: {
		marginTop: 14,
	},
	triggerSettingsCheckboxText: {
		margin: 0,
		minWidth: 400,
	},
	surveyOptionClaim: {
		color: midGrey,
		fontSize: 12,
		marginLeft: 8,
	},
	surveyTriggerCheckboxes: {
		marginTop: 8,
	},
	surveyTriggerCheckboxText: {
		margin: 0,
		// A `large` Checkbox makes its root the 14px square, so a wrapping label overflows the row
		// instead of growing it. Needs a definite width, not a max, or it collapses to min-content.
		width: 470,
	},
	triggerSettingsTitle: {
		marginBottom: 20,
	},
	triggerSettingsWarning: {
		marginLeft: 27,
		marginRight: 27,
		marginTop: 20,
	},
	repeatedRunsDaysInput: {
		marginLeft: 27,
		marginTop: 10,
		display: 'flex',
		alignItems: 'center',
		gap: 10,
		color: '#4a4a4a',
		fontSize: 14,
	},
	renewalSendFromContainer: {
		marginTop: 20,
		paddingTop: 10,
		display: 'flex',
		flexDirection: 'column',
		gap: 10,
	},
	renewalSendFromTitle: {
		color: titles,
		fontSize: 14,
		fontWeight: 600,
		margin: 0,
		marginBottom: 6,
	},
	renewalSendFromOption: {
		display: 'flex',
		alignItems: 'center',
	},
	renewalSendFromOptionLabel: {
		color: '#4a4a4a',
		fontSize: 14,
		marginLeft: 8,
	},
	renewalSendFromHelperText: {
		color: '#777',
		fontSize: 12,
		lineHeight: 1.4,
		marginTop: 8,
		marginLeft: 0,
	},
	renewalSendFromWarningStack: {
		marginTop: 12,
		display: 'flex',
		flexDirection: 'column',
		gap: 10,
	},
});
